export default __webpack_public_path__ + "static/media/restricted_area_bg_img.9ce55bf7.jpg";